import { renderToMarkup } from 'fela-dom';
import {
  ThemeProvider,
  useFela,
  FelaComponent,
  createComponent, // deprecated
  connect, // deprecated
} from 'react-fela';

import StyleProvider, { getRenderer } from './StyleProvider';
import styleConfig from './styleConfig';

export default StyleProvider;

export {
  StyleProvider,
  useFela,
  FelaComponent,
  renderToMarkup,
  styleConfig,
  ThemeProvider,
  getRenderer,
  createComponent, // deprecated
  connect, // deprecated
};

export type { WithTheme, Style } from './ThemeTypes';
